import React from "react";
import InnerLayout from "../InnerLayout";
import { Link } from "react-router-dom";

const hostelSections = [
  {
    id: "girls-hostel",
    label: "Girls Hostel",
    title: "Girls Hostel",
    description:
      "The Girls Hostel provides a safe, comfortable, and student-friendly residential environment. It supports academic focus, personal growth, and community living through essential facilities and disciplined hostel management.",
    image:
      "/Campus/girlHostel.jpg",
    to: "/campus-life/girls-hostel",
  },
  {
    id: "boys-hostel",
    label: "Boys Hostel",
    title: "Boys Hostel",
    description:
      "The Boys Hostel offers residential facilities with essential amenities for students. The hostel environment encourages discipline, peer learning, and a balanced campus life experience.",
    image:
      "/Campus/boyshostel.jpg",
    to: "/campus-life/boys-hostel",
  },
];

const Hostels = () => {
  return (
    <InnerLayout
      title="Hostels"
      image="/Campus/hostel.jpg"
      breadcrumbs={[
        { label: "Campus Life", to: "/campus" },
        { label: "Hostels" },
      ]}
      sidebar={null}
    >
      <section>
        <h2
          className="text-3xl md:text-4xl text-brand font-semibold mb-10"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Hostel Facilities
        </h2>

        <div className="space-y-16">
          {hostelSections.map((hostel, index) => (
            <div
              key={hostel.title}
              id={hostel.id}
              className="grid md:grid-cols-2 gap-8 md:gap-12 items-center"
            >
              <Link
                to={hostel.to}
                className={`aspect-[4/3] overflow-hidden bg-white border border-brand/10 block ${index % 2 === 1 ? "md:order-2" : ""}`}
              >
                  <img
                    src={hostel.image}
                    alt={hostel.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
              </Link>

              <div className={index % 2 === 1 ? "md:order-1" : ""}>
                <p className="text-xs uppercase tracking-[0.28em] text-brand font-semibold mb-3">
                  {hostel.label}
                </p>

                <Link to={hostel.to} className="block hover:underline">
                  <h3
                    className="text-3xl text-brand font-semibold mb-4"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {hostel.title}
                  </h3>
                </Link>

                <p className="text-[#2a2a2a]/85 leading-relaxed text-[16px]">
                  {hostel.description}
                </p>

                <Link
                  to={hostel.to}
                  className="inline-block mt-5 text-sm text-brand font-semibold hover:underline"
                >
                  View details
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </InnerLayout>
  );
};

export default Hostels;